import { z } from "zod";
import { ServiceError } from "../globals";

const cartAuth = z.tuple([z.string(), z.string()]);

export default function parseCart(cartIdentifier?: string) {
  const cart = z.string().safeParse(cartIdentifier);

  if (!cart.success) {
    throw new ServiceError("Cart identifier is missing", {
      statusCode: 400,
      code: "MISSING_CART_IDENTIFIER",
      details: { issues: cart.error.issues },
    });
  }

  const auth = cartAuth.safeParse(cart.data.split(":"));

  if (!auth.success) {
    throw new ServiceError("Faulty cart identifier provided", {
      statusCode: 400,
      code: "FAULTY_CART_IDENTIFIER",
      details: { issues: auth.error.issues },
    });
  }

  return {
    id: auth.data[0],
    token: auth.data[1],
  };
}
